const getters = {
  getCount: state => {
    return state.count
  }
}


export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js